import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _sfc_main } from "./VaBreadcrumbs.vue_vue_type_script_lang-1167e57b.mjs";
import { _ as _VaBreadcrumbsItem } from "./VaBreadcrumbsItem/VaBreadcrumbsItem-ccd593fe.mjs";
const VaBreadcrumbsItem = withConfigTransport(_VaBreadcrumbsItem);
const VaBreadcrumbs = withConfigTransport(_sfc_main);
export {
  VaBreadcrumbsItem as V,
  VaBreadcrumbs as a
};
//# sourceMappingURL=index-7b762035.mjs.map
